import { mapGetters } from 'vuex'
import EnvelopeDataService from '@/services/EnvelopeDataService'
import InvoiceDataService from '@/services/InvoiceDataService'
import moment from 'moment'

export default {
  name: 'ManageInvoice',
  data: () => {
    return {
      dismissSecs: 4,
      dismissCountDownSuccess: 0,
      message: '',
      dialog: false,
      headers: [
        {
          text: 'Nom',
          align: 'start',
          sortable: false,
          value: 'name'
        },
        { text: 'Montant', value: 'montant' },
        { text: 'Enveloppe', value: 'envelope' },
        { text: 'Date', value: 'date' }
      ],
      invoices: [],
      listEnvelope: [],
      envelopes: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        date: '',
        montant: 0,
        envelope: ''
      },
      defaultItem: {
        name: '',
        date: '',
        montant: 0,
        envelope: ''
      },
      isMobile: false,
      isValid: true
    }
  },

  computed: {
    ...mapGetters(['isLogged']),
    formTitle () {
      return this.editedIndex === -1 ? 'Nouvelle facture' : 'Modifier facture'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    this.initialize()
  },

  mounted () {
    this.onResize()

    window.addEventListener('resize', this.onResize, { passive: true })
  },

  beforeDestroy () {
    if (typeof window === 'undefined') return

    window.removeEventListener('resize', this.onResize, { passive: true })
  },

  methods: {
    countDownChangedSuccess (dismissCountDownSuccess) {
      this.dismissCountDownSuccess = dismissCountDownSuccess
    },

    showSuccess () {
      this.dismissCountDownSuccess = this.dismissSecs
    },

    getDisplayInvoice (invoice) {
      return {
        id: invoice.id,
        name: invoice.name,
        envelope: invoice.envelope,
        date: invoice.date,
        montant: invoice.montant
      }
    },

    getAutocompleEnvelopes (envelope) {
      return {
        text: envelope.name,
        value: envelope.id
      }
    },

    initialize () {
      EnvelopeDataService.getAll()
        .then((response) => {
          this.listEnvelope = response.data.content.map(this.getAutocompleEnvelopes)
          for (let index = 0; index < response.data.content.length; index++) {
            this.envelopes[response.data.content[index].id] = response.data.content[index].name
          }
        })

      InvoiceDataService.getAll()
        .then((response) => {
          this.invoices = response.data.content.map(this.getDisplayInvoice)
        })
        .catch((e) => {
          console.log(e)
        })
    },

    onResize () {
      this.isMobile = window.innerWidth < 769
    },

    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    save () {
      let date = ''
      if (this.editedItem.date.length === 0) {
        date = moment().format('DD/MM/YYYY')
      }
      if (this.editedItem.date.length > 0) {
        date = moment(this.editedItem.date).format('DD/MM/YYYY')
      }
      this.editedItem.date = date

      // créer une enveloppe
      InvoiceDataService.create(this.editedItem)
        .then(response => {
          this.invoices.push(response.data.content)
        })
        .catch((e) => {
          console.log(e)
        })

      this.close()
    }
  }
}
